import React, { useState, useEffect } from "react";
import menuIcon from "../../../assets/menu_icon.svg";
import logoMobile from "../../../assets/logo_menu.svg";
import logoDesktop from "../../../assets/imagotype_horizontal.svg";
import { useLocation } from "react-router-dom";

import { MobileMenu } from "../mobile-menu/MobileMenu.component";

export const TopBar = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [logo, setLogo] = useState(null);
  const [logoWidth, setLogoWidth] = useState(null);
  const [logoHeight, setLogoHeight] = useState(null);

  useEffect(() => {
    setShow(false);
    setLogo(window.innerWidth < 768 ? logoMobile : logoDesktop);
    setLogoWidth(window.innerWidth < 768 ? "28px" : "101px");
    setLogoHeight(window.innerWidth < 768 ? "38px" : "28px");
  }, [location]);

  return (
    <>
      <nav className="w-full h-full md:h-[66px] justify-between md:justify-start flex p-2 border items-center">
        <div className="block md:hidden"></div>
        <img
          src={logo}
          alt="menu_logo"
          style={{ width: logoWidth, height: logoHeight }}
          className="ml-10"
        />
        <img
          src={menuIcon}
          alt="menu_button"
          className="block md:hidden cursor-pointer mr-2.5"
          onClick={() => setShow(!show)}
        />
      </nav>
      <MobileMenu show={show} setShow={setShow} />
    </>
  );
};
